import * as api from '../../api/legalizacion-pago-client';
import { 
    GET_PAGO_RECEPCIONADO,
    GET_CONFIG_FORM10,
    GET_MONEDAS,
    GET_PERSONA,
    POST_LEGALIZAR_PAGO
 
} from '../types';

export const obtenerPagoRecepcionado = (query) => ({
    type: GET_PAGO_RECEPCIONADO,
    payload: api.getDatoPagoRecepcionado(query)
});
export const obtenerForm10 = (query) => ({
    type: GET_CONFIG_FORM10,
    payload: api.getConfiguracionForm10(query)
});
export const obtenerMonedas = (query) => ({
    type: GET_MONEDAS,
    payload: api.getMonedas(query)
});
export const obtenerPersona = (query) => ({
    type: GET_PERSONA,
    payload: api.getPersona(query)
});

export const PostLegalizarPago = (newPago) => ({
    type:POST_LEGALIZAR_PAGO,
    payload: api.enviarLegalizacionPago(newPago)
});
